/* AcrylArtistry — Mini QR tabelanin siparis bilgilerini ANA TABELANIN SEPET KALEMINDEN turetir.

   Neden: Mini, order-bump ile eklendiginde ortada Globo formu yoktur; eskiden
   /cart/add.js'e sadece {id, quantity} gidiyordu ve uretime BOS kalem dusuyordu.
   Artik Mini her zaman property ile eklenir; kaynak okunamazsa bile YEDEK PAKET gider.

   Tek dogruluk kaynagi: hem urun sayfasindaki bump (acr-configurator) hem sepet
   cekmecesindeki "Add" karti (acr-cart-bump.js) bu modulu kullanir.

   ANAHTAR YAZIMI: gercek siparislerden birebir sabitlendi (Globo'nun label_on_cart'i).
   Globo'da yazim tutarsiz: "Qr code 1" ama "QR Code 2". OKURKEN duyarsiz arariz,
   YAZARKEN asla tahmin etmeyiz. _has_gpo BILEREK gonderilmez: o Globo'nun kendi
   defter kaydi, elle yazarsak Globo satiri sahiplenip uzerine yazabilir. */
(function () {
  'use strict';

  var MAIN_HANDLE = 'multi-qr-code-business-social-media-sign-payment-sign-instagram-facebook-zelle-venmo-cashapp-qr-code-sign';
  var MINI_HANDLE = 'mini-qr-code-sign';

  function cartUrl(suffix) {
    var base = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
    return base + (suffix || '');
  }
  function addUrl() {
    var u = (window.routes && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add';
    return /\.js$/.test(u) ? u : u + '.js';
  }
  function norm(s) { return String(s == null ? '' : s).toLowerCase().replace(/\s+/g, ' ').trim(); }

  /* Buyuk/kucuk harf ve bosluk duyarsiz property okuma (sadece OKUMA icin). */
  function get(props, names) {
    if (!props) return '';
    var i, k;
    for (i = 0; i < names.length; i++) {
      if (props[names[i]] != null && props[names[i]] !== '') return String(props[names[i]]);
    }
    var keys = Object.keys(props);
    for (i = 0; i < names.length; i++) {
      var want = norm(names[i]);
      for (k = 0; k < keys.length; k++) {
        if (norm(keys[k]) === want && props[keys[k]]) return String(props[keys[k]]);
      }
    }
    return '';
  }

  function metalOf(props) {
    var m = get(props, ['Base And Icons Color', 'Base and Icons Color']);
    return /silver/i.test(m) ? 'Silver' : 'Gold';
  }

  /* Ana tabelanin "Social Media Links" ozeti su formatta:
     '1) Instagram | text under QR: "@x" | QR: uploaded   2) Venmo | ... | QR: PLEASE CREATE from link -> https://...'
     Mini tek QR tasidigi icin hangi slotun gittigini buradan cozeriz. */
  function parseSlots(props) {
    var raw = get(props, ['Social Media Links']);
    var out = [];
    if (!raw) return out;
    var parts = raw.split(/\s{2,}(?=\d+\)\s)/);
    if (parts.length === 1) parts = raw.split(/(?=\d+\)\s)/);
    parts.forEach(function (chunk) {
      chunk = String(chunk).trim();
      if (!chunk) return;
      var m = chunk.match(/^(\d+)\)\s*([^|]+)/);
      if (!m) return;
      var slot = { index: parseInt(m[1], 10), name: m[2].trim(), caption: '', link: '', uploaded: false };
      var cap = chunk.match(/text under QR:\s*"([^"]*)"/i);
      if (cap) slot.caption = cap[1];
      var lnk = chunk.match(/link\s*-(?:&gt;|>)\s*(\S+)/i);
      if (lnk) slot.link = lnk[1].replace(/&amp;/g, '&');
      if (/QR:\s*uploaded/i.test(chunk)) slot.uploaded = true;
      out.push(slot);
    });
    return out;
  }

  /* Yuklenen QR dosyasinin gercek URL'i (Globo yukler, property'ye URL yazar).
     Musteri dosya yerine LINK verdiyse boyle bir property hic olusmaz. */
  function qrUrlFor(props, index) {
    var names = index === 1
      ? ['Qr code 1', 'QR Code 1', 'QR code 1', 'qr code 1']
      : ['QR Code ' + index, 'Qr code ' + index, 'QR code ' + index];
    var v = get(props, names);
    return /^https?:\/\//i.test(v) ? v : '';
  }

  function slotAt(slots, index) {
    for (var i = 0; i < slots.length; i++) { if (slots[i].index === index) return slots[i]; }
    return null;
  }

  /* Musteriye gosterilecek ozet (bump kartindaki tek satir) — property degil. */
  function summary(main, opts) {
    opts = opts || {};
    var slots = parseSlots(main);
    var idx = opts.qrIndex || 1;
    var slot = slotAt(slots, idx);
    var metal = metalOf(main);
    var color = opts.color || get(main, ['BACKGROUND COLOR']);
    var bottom = (opts.bottom != null && opts.bottom !== '')
      ? opts.bottom
      : (get(main, ['Company Name', 'Company name']) || get(main, ['Your Slogan']));
    return {
      color: color, bottom: bottom, metal: metal,
      qrName: opts.qrOther ? 'a different QR code' : (slot ? slot.name : ''),
      qrIndex: idx, slots: slots,
      qrOther: !!opts.qrOther, qrLink: (opts.qrLink || '').trim()
    };
  }

  /* Mini kaleminin property paketi. Bos deger tasiyan anahtar HIC gonderilmez. */
  function build(main, opts) {
    opts = opts || {};
    var s = summary(main, opts);
    var slot = slotAt(s.slots, s.qrIndex);
    var slogan = get(main, ['Your Slogan']);
    var qrUrl = qrUrlFor(main, s.qrIndex);

    var qrInfo;
    /* Musteri Mini'ye BASKA bir QR istiyorsa tabelanin QR'i KOPYALANMAZ. */
    if (s.qrOther) {
      qrInfo = s.qrLink
        ? 'DIFFERENT from the big sign - PLEASE CREATE from link -> ' + s.qrLink
        : 'DIFFERENT from the big sign - customer will send the QR (PLEASE ASK before production)';
    }
    else if (qrUrl) qrInfo = 'same as the main sign -> ' + qrUrl;
    else if (slot && slot.link) qrInfo = 'PLEASE CREATE from link -> ' + slot.link;
    else if (slot && slot.uploaded) qrInfo = 'same as the main sign - use the file on "QR Code ' + s.qrIndex + '" of the big sign line';
    else if (slot) qrInfo = 'not provided on the big sign either - please ask the customer';
    else qrInfo = 'same as the main sign - see the big sign line in this order';

    var icons = s.slots.slice(0, 3).map(function (x) { return x.name; }).join(', ');

    /* Mini'nin KENDI 7 satirlik uretim sablonu yeniden uretilir; ana tabelanin
       "1) .. 2) .." metni HAM KOPYALANMAZ (uretime '5 QR var' talimati gitmesin). */
    var spec = [
      'MINI QR SIGN - order bump, matched to the big sign in this same order',
      'Headline: ' + (slogan || 'same as the big sign'),
      'QR code (one): ' + qrInfo + (s.qrName && !s.qrOther ? '  [' + s.qrName + ']' : ''),
      'Text under the QR: ' + (s.bottom ? '"' + s.bottom + '"' : 'none'),
      'Icons under the text: ' + (icons || 'none'),
      'Background: ' + (s.color || 'same as the big sign')
        + ' | QR frame: ' + s.metal + ' mirror | Stand: ' + s.metal
    ].join('\n');

    var p = {};
    if (s.color) p['BACKGROUND COLOR'] = s.color;
    p['Frame'] = 'Yes';
    p['Frame Color'] = s.metal;
    p['Stand Color'] = s.metal;
    if (slogan) p['Your Slogan'] = slogan;
    if (s.bottom) p['Text at the bottom'] = s.bottom;
    if (icons) p['Desired icons for social medias or payment methods'] = icons;
    if (qrUrl && !s.qrOther) p['Qr code 1'] = qrUrl;
    p['Social Media Links'] = spec;
    p['Design'] = s.qrOther
      ? 'Order bump - matches the big QR sign in this order EXCEPT the QR code: the customer wants a DIFFERENT QR on the mini'
        + (s.qrLink ? ' (create it from the link in "Social Media Links").' : ' - ASK THE CUSTOMER for it before production.')
      : 'Order bump - made to match the big QR sign in this order'
        + (s.qrName ? ' (carries QR ' + s.qrIndex + ': ' + s.qrName + ')' : '') + '.';
    if (opts.mainKey) p['_acr_main_key'] = opts.mainKey;
    p['_acr_bump'] = opts.edited ? 'v1-edited' : 'v1';
    return p;
  }

  /* Ana kalem hic okunamazsa: kalem yine de ASLA bos gitmez. */
  function fallback() {
    return {
      'Social Media Links': 'MINI QR SIGN - order bump\n'
        + 'Please make it match the big QR sign in this same order: same background colour, same text, same QR code.',
      'Design': 'Order bump - please make it match the big QR sign in this order (same colour, same QR code).',
      '_acr_bump': 'fallback'
    };
  }

  function readCart() {
    return fetch(cartUrl('.js'), { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* key verilirse o kalem, verilmezse SON ana tabela kalemi. */
  function findMainLine(key) {
    return readCart().then(function (c) {
      var items = (c && c.items) || [], found = null, i;
      for (i = 0; i < items.length; i++) {
        if (key && items[i].key === key) return items[i];
        if (items[i].handle === MAIN_HANDLE) found = items[i];
      }
      return found;
    }).catch(function () { return null; });
  }

  function countMain(cart) {
    var n = 0;
    ((cart && cart.items) || []).forEach(function (i) { if (i.handle === MAIN_HANDLE) n += i.quantity; });
    return n;
  }

  function add(variantId, props, sectionsUrl) {
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: props }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: sectionsUrl || window.location.pathname
      })
    }).then(function (r) {
      if (!r.ok) { throw new Error('cart/add ' + r.status); }
      return r.json();
    });
  }

  /* Cekmeceyi ve sepet rozetini tazele (cekmece her seferinde innerHTML ile yeniden cizilir). */
  function repaint(sections) {
    if (!sections) return;
    function inner(html, sel) {
      try {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var el = doc.querySelector(sel);
        return el ? el.innerHTML : null;
      } catch (e) { return null; }
    }
    if (sections['cart-drawer']) {
      var cur = document.querySelector('#CartDrawer .drawer__inner');
      var fresh = inner(sections['cart-drawer'], '.drawer__inner');
      if (cur && fresh !== null) cur.innerHTML = fresh;
    }
    if (sections['cart-icon-bubble']) {
      var cb = document.getElementById('cart-icon-bubble');
      var fb = inner(sections['cart-icon-bubble'], '.shopify-section');
      if (cb && fb !== null) cb.innerHTML = fb;
    }
  }

  window.AcrMiniProps = {
    MAIN_HANDLE: MAIN_HANDLE,
    MINI_HANDLE: MINI_HANDLE,
    get: get,
    metalOf: metalOf,
    parseSlots: parseSlots,
    summary: summary,
    build: build,
    fallback: fallback,
    readCart: readCart,
    findMainLine: findMainLine,
    countMain: countMain,
    add: add,
    repaint: repaint
  };
})();
